import { render, staticRenderFns } from "./SettingsPerformanceRatings.vue?vue&type=template&id=7bfbeafe"
import script from "./SettingsPerformanceRatings.vue?vue&type=script&lang=js"
export * from "./SettingsPerformanceRatings.vue?vue&type=script&lang=js"
import style0 from "./SettingsPerformanceRatings.vue?vue&type=style&index=0&id=7bfbeafe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports